import React from "react";
import {Box, Flex, useBreakpointValue} from "@chakra-ui/react";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/sidebar";

const Layout = ({ children, role, setDynamicRoutes }) => {
  const headerHeight = "4rem";
  const contentMarginLeft = useBreakpointValue({ base: 0, md: "240px" });
  const contentPadding = useBreakpointValue({ base: 2, md: 4, lg: 6 });

  return (
    <Flex direction="column" minH="100vh">
      <Header />
      <Flex flex="1" pt={headerHeight} overflowY={"hidden"}>
        <Sidebar role={role} setDynamicRoutes={setDynamicRoutes} />
        <Box
          flex="1"
          pl={contentPadding}
          pt={0}
          pb={contentPadding}
          ml={contentMarginLeft}
          overflowY="auto"
          h={`calc(100vh - ${headerHeight})`}
          maxW="100%"
          position="relative"
        >
          {children}
        </Box>
      </Flex>
    </Flex>
  );
};

export default Layout;
